<template>
    <div class="d-flex flex-wrap flex-md-nowrap gap-4 mb-5">
        <div v-for="(column, columnIndex) in columns" :key="columnIndex" class="flex-grow-1 flex-basis-100">
            <h3 v-if="column.title">{{ column.title }}</h3>
            <p v-if="column.description">{{ column.description }}</p>
            <ul v-if="column.items">
                <li v-for="(item, itemIndex) in column.items" :key="itemIndex">{{ item }}</li>
            </ul>
            <ButtonIcon v-if="column.button" class="w-100 w-md-auto" :to="column.button.to">{{ column.button.label }}</ButtonIcon>
        </div>
    </div>
</template>



<script>
    export default {
        name: 'FeatureColumns',
        props: {
            columns: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>



<style lang="scss" scoped>
    ul {
        list-style: none;
        padding-left: 0;

        li {
            position: relative;
            padding-left: 1.2em;
            font-size: 16px;

            &::before {
                background: $brand;
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 4px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
            }
        }
    }
</style>
